<app-wrapper>

  <div class="mb-9">
    <div class="row g-3 mb-4">
      <div class="col-auto">
        <h2 class="mb-0">Категории</h2>
      </div>
    </div>

    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <!-- <button (click)="addNew()" class="btn btn-primary">
          <i class="fa-solid fa-plus"></i>&nbsp;Добавить категорию
        </button> -->
      </div>
    </div>
  </div>

  <div
    class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1 pt-2 pb-2">
    <ul class="list-group">
      @for (current of items; track current) {
        <ng-container [ngTemplateOutlet]="itemTemplateRef"
          [ngTemplateOutletContext]="{item: current}">
        </ng-container>
      }
    </ul>
  </div>
  @if (isBusy) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
  }
</div>
</app-wrapper>


<ng-template #itemTemplateRef let-item="item">
  <li class="list-group-item">
    <div class="mb-2 mt-2">
      <i class="fa-solid"
        [ngClass]="{'text-danger': !item.isPublished, 'text-success':item.isPublished, 'fa-check': item.isPublished, 'fa-times': !item.isPublished}"
      [title]="item.isPublished ? 'Опубликованна' : 'Снята с публикации'"></i>&nbsp;
      <a [routerLink]="[baseItemUrl, item.id ]">
        {{ item.name }}&nbsp;<i class="fa-solid fa-edit"></i>
      </a>&nbsp;
      <!-- <div class="d-inline ps-2 pe-2 cursor-pointer" (click)="deleteCategory(item.id)" title="Удалить">
      <i class="text-danger fa-solid fa-circle-xmark"></i>
    </div> -->
  </div>

  @if (item.categories.length > 0) {
    <ul class="list-group">
      @for (current of item.categories; track current) {
        <ng-container [ngTemplateOutlet]="itemTemplateRef"
        [ngTemplateOutletContext]="{item: current}"></ng-container>
      }
    </ul>
  }

</li>
</ng-template>